import { careTypeList } from "../utils/careCategoryOptions";

export const useCareType = (caretype) => {
  let returnType = caretype;
  Object.keys(careTypeList).forEach((c) => {
    let careType = careTypeList[c];
    if (careType.value === caretype) returnType = careType.label;
  });
  return returnType;
};
